import { AirdropMementoIcon, BrightBoxIcon, MagnetIcon } from "components/atoms/Icon";
import { EyeSlashIcon } from "@heroicons/react/24/solid";
import { BanknotesIcon, MegaphoneIcon, ShoppingCartIcon } from "@heroicons/react/24/outline";
import { formatToCommaSeparatedString } from "utils/HelperFunctions";
import { useAnalyticsDataProviderContext } from "./AnalyticsDataProvider";
import MetricCard from "./Components/MetricCard/MetricCard";
import UserAvatarForAnalytics from "./Components/UserAvatarForAnalytics";
import BarGraph from "./Components/Graph/BarGraph";
import Carousel from "./Components/Carousel";
import TopMementosTable from "./Components/TopMementosTable";

function BrandAnalytics() {
  const {
    isBrandAnalyticsDataLoading,
    isBrandAnalyticsDataLoadingError,
    brandAnalyticsData,
    brandAnalyticsTopMementosData,
  } = useAnalyticsDataProviderContext();

  if (isBrandAnalyticsDataLoading) {
    return null;
  }

  if (isBrandAnalyticsDataLoadingError) {
    return null;
  }

  if (!brandAnalyticsData) {
    return null;
  }

  return (
    <div className="secondary-scrollbar pl-10 text-white">
      <div className="mb-8">
        <h2 className="-ml-2 mt-2 text-3xl font-bold">Brand Metrics</h2>
        {/* <MetricCardNew
            metricName="Total Mementos"
            metricData={brandAnalyticsData.total_mementos}
            icon={<AirdropMementoIcon className="h-11" color="text-secondary" />}
            label="Memento Created"
          /> */}
        <div className="flex flex-wrap gap-10">
          <MetricCard
            metricName="Total Magnets"
            metricData={brandAnalyticsData.total_magnets}
            icon={<MagnetIcon className="mt-4 h-20 bg-transparent text-secondary" />}
          />
          <MetricCard
            metricName="Total Mementos"
            metricData={brandAnalyticsData.total_mementos}
            icon={<AirdropMementoIcon className="mt-8 h-14" color="text-secondary" />}
          />
          <MetricCard
            metricName="Total Releases"
            metricData={brandAnalyticsData.total_releases}
            icon={<MegaphoneIcon className="mt-6 h-16 text-secondary" />}
          />
          <MetricCard
            metricName="Private Releases"
            metricData={brandAnalyticsData.total_event_releases}
            icon={<EyeSlashIcon className="mr-2 mt-6 h-14 text-secondary" />}
          />
          <MetricCard
            metricName="Magnets Sold"
            metricData={brandAnalyticsData.total_sold}
            icon={<ShoppingCartIcon className="mt-4 h-16 text-secondary" />}
          />
          <MetricCard
            metricName="Mementos Dropped"
            metricData={brandAnalyticsData.total_mementos_dropped}
            icon={<BrightBoxIcon className="mt-4 h-16" color="text-secondary" />}
          />
          <MetricCard
            metricName="Revenue"
            metricData={formatToCommaSeparatedString(brandAnalyticsData.total_revenue, "currency")}
            icon={<BanknotesIcon className="mt-4 h-16 text-secondary" />}
          />
        </div>
      </div>
      <div className="">
        <h2 className="-mr-2 mt-2 text-3xl font-bold">Audience Metrics</h2>
        <div className="flex flex-wrap gap-10">
          <MetricCard
            metricName="Top Magnet Owner"
            metricData={
              <UserAvatarForAnalytics
                email={brandAnalyticsData.top_magnet_owner.email || "User Email"}
                username={brandAnalyticsData.top_magnet_owner.username || "---"}
                profileImageURL={brandAnalyticsData.top_magnet_owner.profile_image_url || ""}
                additionalSubtext={`Magnets Owned: ${brandAnalyticsData.top_magnet_owner.magnets_owned || "(count)"}`}
              />
            }
            className="bg-[#081727]"
          />
          <MetricCard
            metricName="Top Memento Owner"
            metricData={
              <UserAvatarForAnalytics
                email={brandAnalyticsData.top_memento_owner.email || "User Email"}
                username={brandAnalyticsData.top_memento_owner.username || "---"}
                profileImageURL={brandAnalyticsData.top_memento_owner.profile_image_url || ""}
                additionalSubtext={`Mementos Owned: ${
                  brandAnalyticsData.top_memento_owner.mementos_owned || "(count)"
                }`}
              />
            }
            className="bg-[#081727]"
          />
          <MetricCard
            metricName="Total Users"
            metricData={brandAnalyticsData.total_users_count}
            className="bg-[#081727]"
          />
          <MetricCard
            metricName="Avg. Magnets Owned"
            metricData={brandAnalyticsData.average_magnets_owned}
            className="bg-[#081727]"
          />
          <MetricCard
            metricName="Avg. Mementos Owned"
            metricData={brandAnalyticsData.average_mementos_owned}
            className="bg-[#081727]"
          />
        </div>
      </div>
      <div className="mt-10">
        <Carousel
          title={
            <h2 className="-mr-2 mt-8 snap-y snap-mandatory font-satoshi text-3xl font-bold underline">
              Graphical Visualizations
            </h2>
          }
          isPreviewHorizontal
        >
          <BarGraph
            data={brandAnalyticsData?.graph_data?.brand_activity}
            labels={brandAnalyticsData?.graph_data?.labels}
            yTitle="Count"
            title="Brand Activity Insights"
          />
          <BarGraph
            data={brandAnalyticsData?.graph_data?.memento_insights}
            labels={brandAnalyticsData?.graph_data?.labels}
            yTitle="Count"
            title="Memento Insights"
          />
          <BarGraph
            data={brandAnalyticsData?.graph_data?.user_metrics}
            labels={brandAnalyticsData?.graph_data?.labels}
            yTitle="Count"
            title="User Insights"
          />
          <BarGraph
            data={brandAnalyticsData?.graph_data?.revenue_metrics}
            labels={brandAnalyticsData?.graph_data?.labels}
            yTitle="Revenue (in $)"
            title="Revenue Insights"
          />
        </Carousel>
      </div>
      {brandAnalyticsTopMementosData && !!brandAnalyticsTopMementosData.length && (
        <div>
          <h2 className="-mr-2 mb-3 mt-8 snap-y snap-mandatory font-satoshi text-3xl font-bold underline">
            Top Memento Insights
          </h2>
          <TopMementosTable data={brandAnalyticsTopMementosData} />
        </div>
      )}
    </div>
  );
}
export default BrandAnalytics;
